import "~/modules/jquery-global";
import jQuery from "jquery";
import "js-cookie";
import slate from "~/modules/vendor/slate";
import "~/modules/vendor/modernizr";
import "lazysizes";
import "lazysizes/plugins/noscript/ls.noscript";

const $ = jQuery;

window.slate = slate || {};
window.theme = window.theme || {};

$(document).ready(() => {
    const sections = slate.Sections;
    // eslint-disable-next-line no-undef
    sections.register("product", theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $(".in-page-link").on("click", (evt) => {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    const tableSelectors = ".rte table";

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: "rte__table-wrapper",
    });

    // Target iframes to make them responsive
    const iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: "rte__video-wrapper",
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className =
            document.documentElement.className.replace(
                "supports-no-cookies",
                "supports-cookies",
            );
    }
});

$(".live-chat-link a").on("click", () => {
    if (typeof zE !== "undefined") {
        // eslint-disable-next-line no-undef
        zE("webWidget", "open");
    }
});
